import { Subscription, SubscriptionPackage } from "./types";


/*---------------------------------------------------------------------------------------
  SETTING SUBSCRIPTION 
-----------------------------------------------------------------------------------------*/

export const transformSubscription = (res: any): Subscription => {
  return {
    id: res.id,
    created: res.created,
    subscriptionPackage: res.subscriptionPackage,
  };
};

/*---------------------------------------------------------------------------------------
  SETTING SUBSCRIPTION PACKAGES
-----------------------------------------------------------------------------------------*/

export const transformSubscriptionPackage = (res: any): SubscriptionPackage => {
  return {
    id: res.id,
    name: res.name,
    description: res.description,
    price: res.price,
  };
};
